import { render, staticRenderFns } from "./checkin-station-index.vue?vue&type=template&id=caf10618&"
import script from "./checkin-station-index.vue?vue&type=script&lang=js&"
export * from "./checkin-station-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports